import { useTranslation } from "react-i18next";

export function ChemicalInventoryReviewBadge({ reviewState }) {
  const { t } = useTranslation();
  const base =
    "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium";
  switch (reviewState) {
    case "overdue":
      return (
        <span className={`${base} bg-red-100 text-red-800`}>
          {t("chemical.inventory.review_state.overdue")}
        </span>
      );
    case "due_soon":
      return (
        <span className={`${base} bg-amber-100 text-amber-800`}>
          {t("chemical.inventory.review_state.due_soon")}
        </span>
      );
    case "ok":
      return (
        <span className={`${base} bg-emerald-100 text-emerald-800`}>
          {t("chemical.inventory.review_state.ok")}
        </span>
      );
    default:
      return null;
  }
}
